import { IconButton, Menu, MenuItem, TextField, Button as MuiButton } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MdMoreVert, MdRemoveRedEye, MdEdit, MdDelete, MdDone, MdGetApp, MdLink, MdContentCopy } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import CteActions from 'store/ducks/cte';
import ConvocationActions from 'store/ducks/convocations';
import Images from 'assets/img';
import api from 'services/api';
import { cargasAPI } from 'services/apiRest';
import Modal from 'components/Modal';
import styled from 'styled-components';

const ModalContainer = styled.div`
  padding: 20px;
  min-width: 500px;
  max-width: 700px;
`;

const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
`;

const LinkLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #666;
  margin-bottom: 5px;
`;

const LinkInputContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;

const InfoMessage = styled.div`
  padding: 12px;
  background-color: ${props => props.jaExistia ? '#e3f2fd' : '#e8f5e9'};
  color: ${props => props.jaExistia ? '#1976d2' : '#2e7d32'};
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 15px;
`;

export default function PopupMenu({
  viewConvocation,
  tooglePercurseLogs,
  selected,
  data,
  anchorEl,
  open,
  handleClose,
  handleClick,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [download, setDownload] = useState(false);
  const [modalLinkOpen, setModalLinkOpen] = useState(false);
  const [generatedLink, setGeneratedLink] = useState('');
  const [linkJaExistia, setLinkJaExistia] = useState(false);
  const { cte } = useSelector((state) => state.cte);
  const { convocations } = useSelector((state) => state.convocations);
  const { providers } = useSelector((state) => state.providers);

  useEffect(() => {
    if (cte && cte.convocation_id === data.id && download) {
      console.log(cte);
      if (cte.url_mdfe) {
        window.open(cte.url_mdfe);
      }

      if (cte.invoices && Array.isArray(cte.invoices)) {
        for (let i = 0; i < cte.invoices.length; i++) {
          if (cte.invoices[i]?.dacte) {
            window.open(cte.invoices[i].dacte);
          }
        }
      }

      setDownload(false);
      handleClose();
    }
  }, [cte, data.id, download, handleClose]);

  const [dataConvocation] = convocations.filter(
    (convocation) => convocation.id === data.actions
  );

  const handleUpdateConvocation = async () => {
    try {
      await api
        .firestore()
        .collection('convocations')
        .doc(dataConvocation.id)
        .update({
          ...dataConvocation,
          status: 'completed',
        });

      await toast.promise(Promise.resolve(), {
        success: 'Carga encerrada com sucesso!',
      });
    } catch (error) {
      console.error(error);
      await toast.promise(Promise.reject(), {
        error: (err) => `Erro ao encerrar carga: ${err.message}`,
      });
    }

    handleClose();
  };

  const handleGenerateLink = async () => {
    try {
      // Verificar se a carga está encerrada
      if (data.status === 'completed') {
        toast.error('Não é possível gerar link para carga encerrada');
        handleClose();
        return;
      }

      // Buscar ou gerar link via API
      const resultado = await cargasAPI.gerarLinkAcompanhamento(data.id);
      const link = `${window.location.origin}/iniciar-viagem/${resultado.token}`;
      
      // Armazenar link e abrir modal
      setGeneratedLink(link);
      setLinkJaExistia(resultado.ja_existia || false);
      setModalLinkOpen(true);
    } catch (error) {
      console.error('Erro ao gerar link:', error);
      toast.error(error.message || 'Erro ao gerar link. Tente novamente.');
    }
    handleClose();
  };

  const handleCopyLink = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(generatedLink);
        toast.success('Link copiado para a área de transferência!');
      } else {
        // Fallback para navegadores antigos
        const textArea = document.createElement('textarea');
        textArea.value = generatedLink;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        toast.success('Link copiado para a área de transferência!');
      }
    } catch (error) {
      console.error('Erro ao copiar link:', error);
      toast.error('Erro ao copiar link. Tente novamente.');
    }
  };

  const handleCloseModalLink = () => {
    setModalLinkOpen(false);
    setGeneratedLink('');
    setLinkJaExistia(false);
  };

  const handleAction = (action) => {
    switch (action) {
      case 'view':
        const providerView = data.provider_id 
          ? providers.find(p => p.id === data.provider_id)
          : null;
        history.push({
          pathname: '/createConvocation',
          state: {
            selectedId: data.id,
            edit: true,
            view: true,
            convocationId: data,
            provider: providerView,
          },
        });
        break;
      case 'edit':
        const providerEdit = data.provider_id 
          ? providers.find(p => p.id === data.provider_id)
          : null;
        history.push({
          pathname: '/createConvocation',
          state: {
            selectedId: data.id,
            edit: true,
            convocationId: data,
            provider: providerEdit,
          },
        });
        break;
      case 'download':
        dispatch(CteActions.getCteRequest(data.id));
        setDownload(true);
        break;
      case 'delete':
        dispatch(ConvocationActions.setConvocationRequest(data));
        dispatch(ConvocationActions.openDeleteModal());
        break;
      case 'complete':
        handleUpdateConvocation();
        break;
      case 'generateLink':
        handleGenerateLink();
        return; // Não fechar o menu ainda
      default:
        break;
    }
    handleClose();
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={handleClick}
        style={{ padding: '4px' }}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
      >
        <MdMoreVert size={20} style={{ color: '#122d58' }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => handleAction('view')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdRemoveRedEye size={18} style={{ color: '#122d58' }} />
          Visualizar
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('edit')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdEdit size={18} style={{ color: '#4caf50' }} />
          Editar
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('download')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdGetApp size={18} style={{ color: '#2196F3' }} />
          Baixar documentos
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('delete')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdDelete size={18} style={{ color: '#f44336' }} />
          Excluir
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('complete')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdDone size={18} style={{ color: '#4caf50' }} />
          Encerrar
        </MenuItem>
        {data.status !== 'completed' && (
          <MenuItem
            onClick={() => handleAction('generateLink')}
            style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
          >
            <MdLink size={18} style={{ color: '#FF9800' }} />
            Gerar Link
          </MenuItem>
        )}
      </Menu>

      <Modal 
        open={modalLinkOpen} 
        onClose={handleCloseModalLink} 
        title="Link de Acompanhamento"
      >
        <ModalContainer>
          {linkJaExistia && (
            <InfoMessage jaExistia={true}>
              Este link já havia sido gerado anteriormente. Você pode reutilizá-lo.
            </InfoMessage>
          )}
          {!linkJaExistia && (
            <InfoMessage jaExistia={false}>
              Link gerado com sucesso! Compartilhe este link com o motorista.
            </InfoMessage>
          )}
          
          <LinkContainer>
            <LinkLabel>Link de Acompanhamento:</LinkLabel>
            <LinkInputContainer>
              <TextField
                value={generatedLink}
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
                variant="outlined"
                style={{ flex: 1 }}
              />
              <MuiButton
                variant="contained"
                color="primary"
                onClick={handleCopyLink}
                startIcon={<MdContentCopy size={18} />}
                style={{ minWidth: '120px' }}
              >
                Copiar
              </MuiButton>
            </LinkInputContainer>
          </LinkContainer>

          <ButtonsContainer>
            <MuiButton
              variant="outlined"
              onClick={handleCloseModalLink}
              style={{ minWidth: '100px' }}
            >
              Fechar
            </MuiButton>
          </ButtonsContainer>
        </ModalContainer>
      </Modal>
    </>
  );
}
